import {initWidget} from "./init-widget"

window.moneyhub = {
  init: async params => {
    try {
      let widget
      if (params.type === "payment-single" || params.type === "pay-link") {
        widget = await import(`./pay/${params.type}/widget`)
      } else {
        widget = await import(`./${params.type}/widget`)
      }
      return initWidget(widget.default, params)
    } catch (error) {
      const sanitisedType = params.type.replace(/[\r\n]/g, "")
      // eslint-disable-next-line security-node/detect-crlf
      console.log(`Error: widget type '${sanitisedType}' does not not exist`)
      return Promise.reject(error)
    }
  },
}
